import React from 'react'

export default function IconTwoOneCol({ colour = 'currentColor', ...rest }) {
    return (
        <svg
            preserveAspectRatio='none'
            width='264'
            height='24'
            viewBox='0 0 264 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
        >
            <path
                d='M12 0.5H166.67C168.603 0.5 170.17 2.067 170.17 4V20C170.17 21.933 168.603 23.5 166.67 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M12 0.5H166.67C168.603 0.5 170.17 2.067 170.17 4V20C170.17 21.933 168.603 23.5 166.67 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M182.67 0.5H252C253.933 0.500041 255.5 2.06703 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H182.67C180.737 23.5 179.17 21.933 179.17 20V4C179.17 2.067 180.737 0.5 182.67 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M182.67 0.5H252C253.933 0.500041 255.5 2.06703 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H182.67C180.737 23.5 179.17 21.933 179.17 20V4C179.17 2.067 180.737 0.5 182.67 0.5Z'
                stroke='#E1E1E0'
            />
        </svg>
    )
}
